import {Component, Input} from '@angular/core';
import {TranslatePipe} from '@spartacus/core';

@Component({
  selector: 'dcp-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  imports: [TranslatePipe],
})
export class StarRatingComponent {
  @Input() starRating: number;
  public ratings: number[] = [1, 2, 3, 4, 5];

  showHalfStar(starRating: number, currentRating: number): boolean {
    return parseInt(starRating.toString(), 16) + 1 === currentRating && starRating % 1 !== 0;
  }
}
